
/**
 * 实时漫游类
 */
class RealAnimation {
    constructor(options) {
        this.entity = options.entity; //漫游实体
        this.multiple = options.multiple; //倍速
        this.lastTime = undefined;
        this.positions = [];
    }

    update(position, time) {
        var that=this;
        this.positions.push(position);
        if (this.positions.length == 1) {
            this.positions.push(position.clone());
            this.positions.push(position.clone());
        }
        if (!this.lastTime) {
            this.lastTime = time;
            var positionProperty = this.createPositionProperty([position, position], 0)
            this.entity.position = positionProperty;
            this.entity.orientation = new Cesium.VelocityOrientationProperty(positionProperty);
            var positionsProperty = new Cesium.CallbackProperty(function () {
                return that.positions;
            }, false);
            this.entity.polyline.positions = positionsProperty;
            return;
        }

        //this.entity.position.removeSample(this.stopTime);
        var sumTime = (time - this.lastTime) / 1000;

        var startTime = viewer.clock.currentTime; //飞行开始时间
        var sTime = Cesium.JulianDate.addSeconds(startTime, sumTime, new Cesium.JulianDate());
        this.entity.position.addSample(sTime, position);

        viewer.clock.multiplier = this.multiple; //飞行速度 
        viewer.clock.shouldAnimate = true;

    }

    //创建运动属性
    createPositionProperty(positionsArc, time) {
        time = time < 0.01 ? 0.01 : time;
        var property = new Cesium.SampledPositionProperty(); //位置属性
        var startTime = viewer.clock.currentTime; //飞行开始时间
        var stopTime; //飞行结束时间 
        var length = positionsArc.length;//100
        var sumTime = 0;
        for (var i = 0; i < length; i++) {
            var item = positionsArc[i];
            //起点
            if (i === 0) {
                property.addSample(startTime, item);
            }
            else {
                sumTime += time;
                var sTime = Cesium.JulianDate.addSeconds(startTime, sumTime, new Cesium.JulianDate());
                property.addSample(sTime, item);
            }
        }

        var endTime = Cesium.JulianDate.addSeconds(startTime, sumTime, new Cesium.JulianDate());
        var pointEnd = positionsArc[length - 1];
        //为了保证到结束时间了，一直停留在那，所以加个很远的时间
        stopTime = Cesium.JulianDate.addDays(endTime, 365, new Cesium.JulianDate());
        property.addSample(stopTime, pointEnd);
        property.setInterpolationOptions({
            interpolationDegree: 1,
            interpolationAlgorithm: Cesium.LinearApproximation// //Cesium.LagrangePolynomialApproximation //HermitePolynomialApproximation
        });

        this.startTime = startTime;
        this.stopTime = stopTime;
        return property;
    }


    //计算总长(米)
    getLength(positions) {
        if (!Cesium.defined(positions) || positions.length < 2) return 0;

        var distance = 0;
        for (var i = 1, len = positions.length; i < len; i++) {
            distance += Cesium.Cartesian3.distance(positions[i - 1], positions[i]);
        }
        return distance;
    }
}

export default RealAnimation;